import React, { useContext } from "react";
import MenuItem from "./MenuItem";
import { addParentMenu } from "app/services/menuService";
import { useEffect } from "react";
import { useState } from "react";
import AddPopOver from "./AddPopOver";
import { FaLayerGroup } from "react-icons/fa";
import { Col, Nav, Row } from "react-bootstrap";
import { AppContext } from "app/appContext";
import usePagePermission from "app/hooks/usePagePermission";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { getUserPermission } from "app/services/permissionService";

const Menu = () => {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();

  const context = useContext(AppContext);
  const [activeTab, setActiveTab] = useState("ADMIN");
  const [menuState, setMenuState] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [isCollapseAll, setIsCollapseAll] = useState(0);

  const getMenuHandlerForAdmin = async () => {
    setMenuState(context.navData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = {
      name: e.target.name.value,
      icon: e.target.icon.value,
      path: e.target.path?.value,
      description: e.target.description.value,
      menuType: activeTab,
    };

    const newMenu = await addParentMenu(value);
    setMenuState(newMenu.data);
    setIsShow(false);
  };
  const getMenuHandlerForMerchant = async (values) => {
    debugger;

    const menus = await getUserPermission(values);
    if (menus.data) {
      setMenuState(menus.data);
    } else {
      setMenuState([]);
    }
    setIsLoading(true);
  };
  useEffect(() => {
    if (activeTab == "ADMIN") {
      getMenuHandlerForAdmin();
    } else {
      setIsLoading(false);
      getMenuHandlerForMerchant("MERCHANT");
    }
  }, [context.navData, activeTab]);

  return (
    <>
      <Helmet>
        <title>Menu Manage</title>
      </Helmet>

      <Breadcrumb routeSegments={[{ name: "Menu Manage" }]}></Breadcrumb>
      <div className="card border-0 shadow-sm rounded-lg">
        <div>
          <Nav
            justify
            variant="pills"
            activeKey={activeTab}
            onSelect={(key) => setActiveTab(key)}
            className="border-0 px-3"
          >
            <Nav.Item>
              <Nav.Link eventKey="ADMIN" className="px-4 py-2">
                ADMIN
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="MERCHANT" className="px-4 py-2">
                MERCHANT
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="p-1">
            <div className="separator-breadcrumb border-top"></div>
            {canAdd && (
              <div className="d-flex gap-2 float-end">
                <AddPopOver
                  target={target}
                  setTarget={setTarget}
                  setIsShow={setIsShow}
                  isShow={isShow}
                  ParentMenu="ParentMenu"
                  handleSubmit={handleSubmit}
                />
                <button
                  type="button"
                  className="btn btn-outline-primary d-flex align-items-center gap-2 shadow-sm"
                  onClick={() => setIsCollapseAll(isCollapseAll + 1)}
                  style={{ transition: "all 0.2s ease" }}
                >
                  <FaLayerGroup />
                  <span className="d-none d-sm-inline">Collapse All</span>
                </button>
              </div>
            )}
            {activeTab === "ADMIN" && (
              <div className="card-body p-2">
                <h5>Admin User Access Menu</h5>
                {menuState?.length > 0 ? (
                  <div className="menu-items-list">
                    {menuState.map((item, index) => (
                      <MenuItem
                        disableUpOrder={index == 0}
                        disableDownOrder={menuState.length == index + 1}
                        key={item.id}
                        item={item}
                        menuState={menuState}
                        setMenuState={setMenuState}
                        isCollapseAll={isCollapseAll}
                        type={"ADMIN"}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <div className="mb-3">
                      <FaLayerGroup
                        size={56}
                        className="text-muted"
                        style={{ opacity: 0.4 }}
                      />
                    </div>
                    <h5 className="text-muted mb-2">No Menu Items Yet</h5>
                    <p className="text-muted small mb-0">
                      Get started by adding your first menu item using the
                      button above
                    </p>
                  </div>
                )}
              </div>
            )}
            {activeTab === "MERCHANT" && (
              <div className="card-body p-2">
                <h5>Merchant User Access Menu</h5>
                {menuState?.length > 0 || isLoading ? (
                  <div className="menu-items-list">
                    {menuState.map((item, index) => (
                      <MenuItem
                        disableUpOrder={index == 0}
                        disableDownOrder={menuState.length == index + 1}
                        key={item.id}
                        item={item}
                        menuState={menuState}
                        setMenuState={setMenuState}
                        isCollapseAll={isCollapseAll}
                        type={"MERCHANT"}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <div className="mb-3">
                      <FaLayerGroup
                        size={56}
                        className="text-muted"
                        style={{ opacity: 0.4 }}
                      />
                    </div>
                    <h5 className="text-muted mb-2">No Menu Items Yet</h5>
                    <p className="text-muted small mb-0">
                      Get started by adding your first menu item using the
                      button above
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;
